






























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import LinkButtonIcon from '@/components/atoms/LinkButtonIcon.vue';
import ProductMenuLink from '@/components/molecules/ProductMenuLink.vue';
import { ClickProductUrlEvent, ProductMenu, MenuType } from '@/types/type';

@Component({
  components: { ProductMenuLink, LinkButtonIcon },
})
export default class LinkButtons extends Vue {
  @Prop()
  private menus!: ProductMenu[];

  @Emit('link-opened')
  private linkOpened(event: ClickProductUrlEvent): ClickProductUrlEvent {
    return event;
  }
}
